import { InfoOutlined } from "@material-ui/icons";
import React, { FC } from "react";

import { INFO_MESSAGES_STR } from "../DisplayFileComponent/constants";
import useStyles from "./styles";

export type TMessageType =
  | "info"
  | "file-size-error"
  | "file-type-error"
  | "uploading-error"
  | "redirecting";

interface TInfoMessageComponentProps {
  messageType: TMessageType;
  errorMessageFromApi: string;
  isLoading: boolean;
}

const InfoMessageComponent: FC<TInfoMessageComponentProps> = ({
  messageType,
  errorMessageFromApi,
  isLoading
}) => {
  const classes = useStyles({});

  if (isLoading) {
    return <></>;
  }

  if (messageType === "redirecting") {
    return (
      <div className={classes.redirectTextContainer}>
        You will now be redirected to preview your unlock codes…
      </div>
    );
  }

  if (errorMessageFromApi !== "") {
    return (
      <div className={classes.messageWithButtonContainer}>
        <div className={classes.errorTextContainer}>
          <InfoOutlined
            fontSize="small"
            style={{
              position: "relative",
              top: 1
            }}
          />
          {errorMessageFromApi}
        </div>
      </div>
    );
  }

  if (messageType === "info") {
    return (
      <div className={classes.infoTextContainer}>
        <InfoOutlined
          fontSize="small"
          style={{
            position: "relative",
            top: 1,
            margin: 4
          }}
        />
        <span>
          Once you click on <b>upload</b>, unlock code uploading can’t be
          aborted.
        </span>
      </div>
    );
  }

  return (
    <div className={classes.errorTextContainer}>
      <InfoOutlined
        fontSize="small"
        style={{
          position: "relative",
          top: 1
        }}
      />
      {INFO_MESSAGES_STR[messageType]}
    </div>
  );
};

export default InfoMessageComponent;
